import React, { HTMLAttributes, useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import classNames from "classnames";
import { isNullOrUndefined } from "@app/utilities/helpers";

type ISimpleCollapsibleHocProps = {
  id: string;
  title: string;
  children: React.ReactElement;
  open?: boolean;
  className?: string;

  onToggled?: (key: string, isExpanded: boolean) => void;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collapsibleProps?: HTMLAttributes<HTMLDivElement>;
};

const SimpleCollapsibleHoc: React.FC<ISimpleCollapsibleHocProps> = ({ id, title, children, open, className, onToggled, collapsibleProps }) => {
  const classes = classNames("simple-collapsible-hoc", className),
    [expanded, setExpanded] = useState(!!open),
    onTitleClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
      evt.preventDefault();
      setExpanded(!expanded);
      if (onToggled && typeof onToggled === "function") {
        onToggled(id, !expanded);
      }
      return false;
    };

  useEffect(() => {
    if (!isNullOrUndefined(open)) {
      setExpanded(open);
      return;
    }
  }, [open]);

  if (!collapsibleProps) {
    collapsibleProps = {};
  }

  return (
    <div className={classes}>
      <a className="collapsible-link link" aria-label={title} onClick={onTitleClick}>
        {title}&nbsp;
        {expanded ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
      </a>
      <Collapse timeout={0} in={expanded}>
        <div className="collapsible-container" {...collapsibleProps}>
          {children}
        </div>
      </Collapse>
    </div>
  );
};

export default SimpleCollapsibleHoc;
